import { render, staticRenderFns } from "./Overview2.vue?vue&type=template&id=4b599de4&"
import script from "./Overview2.vue?vue&type=script&lang=js&"
export * from "./Overview2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports